import React, {useCallback, useMemo, useState} from 'react';
import './Colors.sass';
import {ColorUnit} from '~/common/fabric/Card/components/ColorUnit/ColorUnit';

export const Colors = ({
  colors,
  onClick,
  square = false,
  highlight = true,
  className = '',
  height = 32,
  width = 32,
  mobile,
  disabled = false,
}) => {
  const [selectedColor, setSelectedColor] = useState('');

  const onClickHandler = useCallback(
    (value) => {
      setSelectedColor(value);
      onClick(value);
    },
    [onClick]
  );

  const colorsMemo = useMemo(
    () =>
      colors?.map((color) => (
        <ColorUnit
          color={color}
          key={color}
          onClick={onClickHandler}
          square={square}
          isActive={selectedColor === color && highlight}
          height={height}
          width={width}
          disabled={disabled}
          dataQaId={`step1-textcolor-${color}`}
        />
      )),
    [colors, selectedColor, disabled]
  );
  return <div className={`colors ${className} ${mobile && 'colors--mobile'}`}>{colorsMemo}</div>;
};
